module.exports = __webpack_public_path__ + "static/media/linux.2b745a7f.png";